<template>
  <div class="alert alert-success my-1 px-2 py-1" role="alert">
    Успешно! Ваше имя пользователя и пароль отправлены вам в смс.
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      //
    };
  },
  props: {
    //
  },
  methods: {
    //
  },
};
</script>
